import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Subject, tap } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-dropdown-complete',
  templateUrl: './dropdown-complete.page.html',
  styleUrls: ['./dropdown-complete.page.scss'],
})
export class DropdownCompletePage implements OnInit {
  @ViewChild('myNgSelect') myNgSelect!: NgSelectComponent;
  @Input() data :any; 
  @Output() newItemEvent = new EventEmitter<{}>();
 
  custLoading = false;
  custTypeahead = new Subject<string>();
  items:any=[];
  loading=false; 
  selectedItem:any={};

  is_array=false;

  model:any={};

  show_addedit_form=false;
  loading_select=false;
  role: any;

  constructor(private cd: ChangeDetectorRef,public apiService:ApiService) { }

    ngOnInit() {
      let role = localStorage.getItem('role_detail');
    if(role){
      this.role = JSON.parse(role);

      console.log(this.role);
    }
        this._init();
        this.subscribeToCustTypeahead();
    }
 
    private subscribeToCustTypeahead() {
      this.custTypeahead.pipe(
        tap((term) => this.loadItems(term)),
      ).subscribe();
    }


    _init(){
     // console.log(this.data.collection,this.data.item);
      this.loading=true;
      this.custLoading=true;
      let _canLoad=true;
      if(this.data.item ){
        if(this.selectedItem?.id==this.data.item?.id){
          _canLoad=false; 
        }

        //check if array
        if(Array.isArray(this.data.item)){
          console.log('Array');
          this.is_array=true;
          this.selectedItem=[];
          this.data.item.forEach(item => {
            if(item.name){
              this.items.push({id:item.id,name : item.name});
           
              this.selectedItem.push(item.id);
            }
          });
         // this.selectedItem=this.data.item;
          _canLoad=false; 
        } else{

          this.selectedItem=this.data.item.id ?? this.data.item ??{};

        
        
         _canLoad=false; 

        if(this.data.return=='name'){
          let random_id= Math.random();
           this.selectedItem={id:random_id,name:this.data.item};
        }
        
        if(this.data.item?.name){
          this.items.push({id:this.data.item.id,name : this.data.item.name})
        }
        this.items.push(this.selectedItem);
        console.log(this.items);
        _canLoad=false; 
        }
      }
       
     // if(this.item != this.selectedPerson || !this.selectedPerson){
      setTimeout(()=>{
        this.loading=false; 
        this.custLoading=false;
      },3000);

     if(_canLoad){
     this.loadItems();
     }
     // }
    }

    trackByFn(item: any) {
        return item.id;
    }

   async  loadItems(term?) {
    

        console.log(term,this.data);
        let filter:any={};
        if(term){
          switch(this.data?.collection){

            case 'customers':
              filter= { "_or": [{name:{'_contains': term}}]};

              if (isNaN(term) === false) {
                filter._or.push({idseq_app:{'_eq': term}});
              }

              break;

              case 'tracks':
              filter= { "_or": [{name:{'_contains': term}},{isrc :{'_contains': term}}]};
              break;
            
            default:
              filter= { "_or": [{name:{'_contains': term}}]};
              break;
          }
         
        }
        try {
          this.custLoading = true;
         // filter.app=this.apiService.current_active_app.id;
          const x = await this.apiService.get(this.data.collection, { filter: filter , limit: 10000},false);
      
          if (x && x.data.length > 0) {

            this.items = x.data;
            // if(this.data.isContributors){
            //   this.items = x.data.filter(item => !this.isSelected(item.id));
            // }
            // if(this.data.isTrackContributors){
            //   this.items = x.data.filter(item => !this.isSelectedTrackCon(item.id));
            // }
          } else{
            this.items = [];
          }
      
          console.log('x', x);
      
          this.custLoading = false;
          this.cd.markForCheck();
        } catch (error) {
          console.error('Error:', error);
          this.items = [];
        }


    }

    onInputChange(event: any) {
      const inputValue: string = event.target.value;
      
      // Emit the input value to trigger typeahead
//      this.custTypeahead.next(inputValue);
    
      // If the input is empty, manually emit an empty string to trigger typeahead
      if (inputValue === '') {
        this.custTypeahead.next('');
      }
    }

    setNewItem(value:any){  
      console.log("EmitPre",value);
        if(this.data?.return=='id'){
          value=value?.id ?? value; 
        } else  if(this.data?.return=='object'){
           value=value;
        } else  if(this.data?.return=='name'){
          value=value.name;
       } else{
          value=value?.id ?? value;
        }
        console.log("EmitPost",value);
        console.log(this.selectedItem,this.items);
       // if(this.is_array){
      //    this.newItemEvent.emit(this.selectedItem);
      //  }else{
        this.newItemEvent.emit(value); 
        //}
    }
    otherFormSubmit() {
      this.loading_select = true;
      this.apiService.save(this.data.collection, this.model).subscribe((response: any) => {
        this.show_addedit_form = false;
  
        if (this.is_array) {
          this.items.push(response.data);
          if (!Array.isArray(this.selectedItem)) {
            this.selectedItem = [];
          }
          this.selectedItem.push(response.data.id);
  
          let selectedItems: any[] = [];
          this.selectedItem.forEach(item => {
            if (item) {
              let selected_itemm: any = this.items.find(x => x.id === item);
              if (selected_itemm?.id) {
                selectedItems.push(selected_itemm);
              }
            }
          });
  
          this.setNewItem(selectedItems);
        } else {
          this.selectedItem = response.data.id;
          this.setNewItem(response.data);
        }
        console.log(this.selectedItem, response.data, this.items);
  
        this.model = {};
        this.loading_select = false;
      });
    }
   
    isSelected(itemId: any): boolean {
      return this.data.selectedItems.includes(itemId);
    }

    isSelectedTrackCon(itemID: any): boolean{
    //  console.log(this.data.selectedItemsTracksCon);
      return this.data.selectedItemsTracksCon.includes(itemID);
    }
  
  

  addItem(searchItem:any){
    this.myNgSelect.close(); 
this.show_addedit_form=true;
this.model.name=searchItem;
  }
}
